import { CommonModule } from '@angular/common';
import { Component, Input, input, output } from '@angular/core';

@Component({
  selector: 'ui-chip',
  templateUrl: './chip.component.html',
  imports: [CommonModule],
})
export class ChipComponent {
  readonly label = input<string>('');
  @Input() icon?: string;
  readonly removable = input(false);
  readonly remove = output<void>();
  readonly disabled = input(false);

  handleRemove(event: Event) {
    event.stopPropagation();
    if (!this.disabled()) this.remove.emit();
  }
}
